<div class="flex-col">
  <div class="flex-table">
    <div class="flex-header-row">
      <div class="flex-2">Item</div>
      <div class="flex-2">Lengte (cm)</div>
      <div class="flex-2">Beschrijving</div>
      <div class="flex-2">Aantal</div>
      <div class="flex-1"></div>
    </div>
    <div
      class="flex-table-row"
      [ngClass]="i > 0 ? 'small-upper-space' : ''"
      *ngFor="let material of constructionMaterials; index as i"
    >
      <div class="flex-table-cell flex-2">
        {{ material.label }}
      </div>
      <div class="flex-table-cell flex-2">
        {{ material.length }}
      </div>
      <div class="flex-table-cell flex-2">
        {{ material.description }}
      </div>
      <div class="flex-table-cell flex-2">
        {{ material.amount }}
      </div>
      <div class="flex-1 align-flex-end">
        <mat-checkbox
          [(ngModel)]="material.loaded"
          [disabled]="disabled"
          (ngModelChange)="change.emit()"
        ></mat-checkbox>
      </div>
    </div>
  </div>
</div>
